// import { useState } from 'react'

interface FallbackEditorProps {
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
  onKeyDown?: (e: React.KeyboardEvent) => void
  placeholder?: string
  className?: string
  autoFocus?: boolean
  height?: number
}

const FallbackEditor = ({
  value,
  onChange,
  onBlur,
  onKeyDown,
  placeholder = '輸入內容...',
  className = '',
  autoFocus = false,
  height = 200
}: FallbackEditorProps) => {
  return (
    <div className={`fallback-editor-wrapper ${className}`}>
      <div className="border border-gray-300 rounded-md">
        {/* 簡單工具列 */}
        <div className="flex items-center space-x-2 p-2 border-b border-gray-200 bg-gray-50">
          <button
            type="button"
            className="px-2 py-1 text-sm font-bold hover:bg-gray-200 rounded"
            onClick={() => {
              const textarea = document.querySelector('.fallback-textarea') as HTMLTextAreaElement
              if (textarea) {
                const start = textarea.selectionStart
                const end = textarea.selectionEnd
                const selectedText = value.substring(start, end)
                const newValue = value.substring(0, start) + `<strong>${selectedText}</strong>` + value.substring(end)
                onChange(newValue)
              }
            }}
          >
            B
          </button>
          <button
            type="button"
            className="px-2 py-1 text-sm italic hover:bg-gray-200 rounded"
            onClick={() => {
              const textarea = document.querySelector('.fallback-textarea') as HTMLTextAreaElement
              if (textarea) {
                const start = textarea.selectionStart
                const end = textarea.selectionEnd
                const selectedText = value.substring(start, end)
                const newValue = value.substring(0, start) + `<em>${selectedText}</em>` + value.substring(end)
                onChange(newValue)
              }
            }}
          >
            I
          </button>
        </div>
        
        {/* 文本區域 */}
        <textarea
          className={`fallback-textarea w-full p-3 border-0 resize-none focus:outline-none focus:ring-0`}
          style={{ height: `${height}px` }}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          autoFocus={autoFocus}
        />
      </div>
    </div>
  )
}

export default FallbackEditor